// extracted by mini-css-extract-plugin
module.exports = {"text":"index_text_3MG7p","pepText":"index_pepText_2HPhK","tooltip":"index_tooltip_1bncf"};